import { Component, OnInit } from "@angular/core";
import { GenderType, Person } from "../../models/persons/person";
import { StateProvince } from "../../models/lookup/state-province";
import { ClientService } from "../../services/persons/client.service";
import { HelperService } from "../../services/helpers/helper.service";
import { LookupService } from "../../services/lookup.service";
import { NgForm } from "@angular/forms";
import { ModalReference } from "@developer-partners/ngx-modal-dialog";

@Component({
    templateUrl: './create-client.component.html'
})
export class CreateClientComponent implements OnInit {
    public client: Person = { primaryEmail: {}, primaryPhone: { text: '' } };
    public isLoading = false;
    public loadingMessage = '';
    public validationErrors: string[] = [];
    public genderType = GenderType;
    public states: StateProvince[] = [];

    constructor(
        private readonly _clientService: ClientService,
        private readonly _helper: HelperService,
        private readonly _lookupService: LookupService,
        private readonly _modalRef: ModalReference<Person>
    ) {}

    public async ngOnInit(): Promise<void> {
        this.isLoading = true;
        this.states = await this._lookupService.getAllStates();
        this.isLoading = false;
    }

    public async save(form: NgForm): Promise<void> {
        if (!form.valid) return;

        try {
            this.isLoading = true;
            this.client.gender = +this.client.gender!;
            this.validationErrors = [];

            const result = await this._clientService.add(this.client);
            if (result) {
                this._modalRef.closeSuccess(result);
            }
        } catch (e) {
            if (!this._helper.parseValidationErrors(e, this.validationErrors)) {
                throw e;
            }
        } finally {
            this.isLoading = false;
        }
    }

    public cancel(): void {
        this._modalRef.cancel();
    }

    public stateChanged(stateId?: number): void {
        this.client.state = stateId ? { id: stateId } : undefined;
    }

    public primaryEmailChanged(email?: string): void {
        this.client.primaryEmail = { text: email };
    }

    public phoneNumberChanged(phone?: string): void {
        this.client.primaryPhone = { text: phone || '' };
    }
}
